module.exports = __webpack_public_path__ + "img/iteck-edu.b05696c8.png";